import LanguageIcon from '@mui/icons-material/Language';
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";

export default function CheckboxFilter({ 
    filterKey, 
    label, 
    allowGlobal = false,
    disabled = false,
    onFilterChange, 
    currentFilter
}) {
    const [checked, setChecked] = useState(false);

    // Inizializza il valore basandoti sul currentFilter
    useEffect(() => {
        setChecked(!!currentFilter?.value);
    }, [currentFilter]);

    const handleCheckboxChange = (isChecked) => {
        if (disabled) return;

        setChecked(isChecked);

        if (onFilterChange) {
            const filter = {
                key: filterKey,
                value: isChecked ? 'true' : undefined,
                label: isChecked ? 'true' : undefined,
                global: allowGlobal
            };
            onFilterChange(filter);
        }
    };

    return (
        <div className="px-4 border-b">
            <FormControl 
                component="fieldset" 
                disabled={disabled}
                sx={{ width: '100%' }}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={(e) => handleCheckboxChange(e.target.checked)}
                            disabled={disabled}
                            size="small"
                            sx={{
                                color: disabled ? 'action.disabled' : 'primary.main',
                            }}
                        />
                    }
                    label={
                        <Box display="flex" alignItems="center">
                            {allowGlobal && (
                                <LanguageIcon 
                                    fontSize="small" 
                                    sx={{ 
                                        mr: 1, 
                                        color: disabled ? 'action.disabled' : 'action.active' 
                                    }} 
                                />
                            )}
                            <Typography 
                                variant="body2" 
                                sx={{ 
                                    color: disabled ? 'text.disabled' : 'text.primary',
                                    fontWeight: 500
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                    }
                    disabled={disabled}
                    sx={{ mx: 0 }}
                />
            </FormControl>
        </div>
    );
}